<template>
  	<div class="wrapper-card-tool">
		<v-layout
			justify-space-between
			align-center
			class="card-tool"
			:class="{ 'card-total-reverse': cardReverse, 'small-height': smallHeight }"
		>
			<button
				v-if="btnRotated"
				class="card-total-btn"
				type="button"
				@click="$emit('reverse-card', data)"
			>
					<app-tooltip-button
						icon="chevron_right"
						text=""
					/>
			</button>
			<template v-if="cardReverse">
				<v-layout row wrap class="wrapper-info">
					<v-flex xs12>
						<v-layout row wrap align-start>
							<v-flex :class="`${smallHeight ? 'xs1' : 'xs2 text-xs-right pr-2'}`">
								<img
									:src="data.tool ? data.tool.urlImage : data.urlImage"
									:alt="data.tool ? data.tool.name : null"
									height="19"
								/>
							</v-flex>
							<v-flex xs10 px-2>
								<p style="margin-bottom: 15px;">
									<span
										class="card-total-text"
										:style="`color:${$appColors.info};text-transform:uppercase`"
									>
										{{ data.name }}
									</span>
								</p>
								<span
									class="card-total-reverse-data"
									:style="`color:${$appColors.info}`"
								>
									<template v-if="data.description">{{ data.description }}</template>
									<template v-else>No se encontró información</template>
								</span>
								<!-- <p
									v-if="smallHeight"
									class="card-total-reverse-subtitle ma-0"
									:style="`color:${$appColors.info}`"
								>
									Recomendación
								</p>
								<span
									class="card-total-reverse-data"
									:style="`color:${$appColors.info}`"
								>
									<template v-if="data.recommandation">{{ data.recommandation }}</template>
									<template v-else>No se encontró información</template>
								</span> -->
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</template>
			<template v-else>
				<v-flex xs7>
					<div class="wrapper-image"
						:style="`border-color:${data.colorCode || $appColors.primary}`"
					>
						<img
							:src="data.tool ? data.tool.urlImage: data.urlImage"
							:alt="data.tool ? data.tool.name : null">
					</div>
					<div class="text-image"
						:style="`color:${$appColors.info}`"
					>{{data.tool ? data.tool.name : data.name }}</div>
					<div v-if="!small">
						<v-btn
							color="primary"
							class="btn-small-primary ma-0"
							@click="$emit('view-summary', data)">
							<img
								class="mr-2"
								src="/static/img/factor/summary.svg"
								alt="summary">
							Resumen
						</v-btn>
						<v-btn
							color="primary"
							class="btn-small-primary ma-0"
							v-if="graphic"
							@click="$emit('view-graphic', data)">
							<img
								class="mr-2"
								src="/static/img/factor/graphic.svg"
								alt="graphic">
							Gráficos
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs5 class="center">
					<v-progress-circular
						:rotate="360"
						:size="big ? 161 : 97"
						:width="1"
						:value="value"
						:color="data.colorCode || 'secondary'"
					>
						<div v-if="small">
							<span class="title-circular">Total:</span>
							<div class="bold-summary">{{value.toFixed(2)}}</div>
						</div>
						<template v-else>
							<span class="text-circular">{{value ? value : percentage}} %</span>
						</template>
					</v-progress-circular>
				</v-flex>
			</template>
		</v-layout>
		<row-graphic
			v-if="numberGraphic"
			class="mt-3 height-graphic"
			:applicants="data.totalResolved"
			legend-border-right
			:row="dataGraphic"
			:total-applicants="data.numApplicants"
			:view-applicants="viewApplicants"
			@open-applicants="openApplicants"
		/>
	</div>
</template>
<script>
import rowGraphic from '@/components/surveys/action-one/row-graphic';

function mounted() {
	setTimeout(() => {
		this.value = this.data.total || this.data.value || 0;
	}, 800);
}

function dataGraphic() {
	const [male, female] = this.data.graphic;
	male.number = this.data.numMale;
	male.numberTotal = this.data.numTotalMale;
	female.number = this.data.numFemale;
	female.numberTotal = this.data.numTotalFemale;
	return [male, female];
}

function data() {
	return {
		interval: {},
		value: 0,
	};
}

function openApplicants() {
	this.$emit('open-applicants', this.data);
}

export default {
	name: 'card-tool',
	data,
	components: {
		rowGraphic,
	},
	computed: {
		dataGraphic,
	},
	methods: {
		openApplicants,
	},
	mounted,
	props: {
		big: {
			default: false,
			type: Boolean,
		},
		btnRotated: {
			default: true,
			type: Boolean,
		},
		cardReverse: {
			default: false,
			type: Boolean,
		},
		data: {
			type: Object,
			default: () => {},
		},
		index: [Number, String],
		graphic: {
			type: Boolean,
			default: false,
		},
		viewApplicants: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		smallHeight: {
			type: Boolean,
			default: false,
		},
		numberGraphic: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-card-tool {
		max-width: 492px;
	}

	.card-tool {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, border-gray);
		border-radius: 4px;
		box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
		height: 210px;
		padding: 25px 30px;
		position: relative;
		transition: all .5s ease-in;

		&.small {
			height: 143px;
		}

		&.small-height {
			height: 161px;
		}
	}

	.wrapper-image {
		border-bottom: 1px solid;
		margin-bottom: 10px;
		padding-bottom: 20px;
		width: 95px;
	}

	.text-image {
		font-family: font(regular);
		font-size: size(medium);
		margin-bottom: 15px;
		min-height: 47px;
		text-transform: uppercase;
		width: 100px;
	}

	.btn-small-primary {
		border-radius: 13px;
		box-shadow: none !important;
		color: map-get($colors, white) !important;
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, xsmall);
		height: 24px;
		text-transform: none !important;
		width: 90px;
	}

	.text-circular {
		font-family: 'Arial';
		font-size: 40px;
		width: 100%;
	}

	.bold-summary {
		font-family: font(bold);
		font-size: size(sbig);
	}

	.title-circular {
		font-size: size(small);
	}

	.card-total-btn {
		position: absolute;
		right: 20px;
		top: 18px;
		z-index: 2;
	}

	.card-total-text {
		font-family: font(bold);
		font-size: size(medium);
	}

	.card-total-reverse {
		padding: 0px 10px;
		transform: rotateY(180deg);

		.card-total-btn {
			left: 20px;
		}

		.wrapper-info {
			transform: rotateY(-180deg);
		}

		&-data {
			display: inline-block;
			font-size: size(medium);
			height: 76px;
			line-height: normal;
			overflow: auto;
		}

		&-subtitle {
			font-family: font(bold);
			font-size: size(small);
		}
	}

	.small-height {
		.card-total-reverse-data {
			display: inline-block;
			font-size: size(small13);
			line-height: 1;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/card-tool.vue